import React, { FC, KeyboardEvent } from 'react'
import {
  ImageBlockWrapper,
  ImageWrapper,
  Image,
} from './ImageBlock.elements'

type Props = {
  imageUrl: string
  imageUrlMobile: string
  imageHeight: string
  imageHeightMobile: string
  imageMarginBottomMobile: string
  onAction?: () => void
}

export const ImageBlock: FC<Props> = ({
  imageUrl,
  imageUrlMobile,
  imageHeight,
  imageHeightMobile,
  imageMarginBottomMobile,
  onAction,
}) => {
  const handleAction = () => {
    onAction && onAction()
  }

  const handleKeyPressAction = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onAction && onAction()
    }
  }

  return (
    <ImageBlockWrapper>
      <ImageWrapper
        onClick={handleAction}
        onKeyPress={handleKeyPressAction}
        tabIndex={onAction ? 0 : undefined}
        isActionable={!!onAction}
        aria-label={onAction ? 'Press to see details' : undefined}
      >
        <Image
          imageUrl={imageUrl}
          imageUrlMobile={imageUrlMobile}
          imageHeight={imageHeight}
          imageHeightMobile={imageHeightMobile}
          imageMarginBottomMobile={imageMarginBottomMobile}
        />
      </ImageWrapper>
    </ImageBlockWrapper>
  )
}
